/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Reveal_DoneInputs */

const vi_api_keys_reveal_done = /** @type {(inputs: Api_Keys_Reveal_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tôi đã lưu khóa`)
};

/**

* @param {Api_Keys_Reveal_DoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_reveal_done = /** @type {((inputs?: Api_Keys_Reveal_DoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Reveal_DoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_reveal_done(inputs)
});